import React from "react";
import Icon from "./Icon";
import SectionHeader from "./SectionHeader";
import tiolLogo from "../../assets/img/tiolLogo.png";

const STEPS = [
  {
    k: "01 · SOURCE",
    variant: "source",
    t: "Raw judgments & orders",
    d: "Courts and tribunals across India issue a constant stream of decisions — many routine or repetitive.",
  },
  {
    k: "02 · TIOL CURATION",
    variant: "tiol",
    t: "Pruned & organised",
    d: "TIOL selects the decisions that matter and reports them with consistent citations.",
  },
  {
    k: "03 · VEDUM AI",
    variant: "vedum",
    t: "Retrieve, reason, rank",
    d: "Vedum finds the authorities relevant to your question and your matter’s issues.",
  },
  {
    k: "04 · YOUR ANSWER",
    variant: "answer",
    t: "Cited brief & draft",
    d: (
      <>
        Every proposition linked to a citation like{" "}
        <span className="vd-cite-inline">2019-TIOL-2621-CESTAT-AHM</span>.
      </>
    ),
  },
];

const BENEFITS = [
  {
    icon: "filter",
    b: "Less noise.",
    t: "The AI reasons over decisions worth citing, not every order on record.",
  },
  {
    icon: "check",
    b: "Verifiable citations.",
    t: "TIOL citations your team and the bench already recognise.",
  },
  {
    icon: "clock",
    b: "Kept current.",
    t: "New tax rulings reach your research and alerts as they are reported.",
  },
];

const TiolPartnership = () => (
  <section id="partner" className="vd-section vd-section--soft">
    <div className="container">
      <div className="row g-5 align-items-stretch">
        <div className="col-lg-7">
          <span className="vd-eyebrow">STRATEGIC PARTNERSHIP</span>
          <h2 className="vd-h2">
            Better answers start with better case law. That’s why we partnered
            with TIOL.
          </h2>
          <p className="vd-lead mb-3">
            Vedum has partnered with <strong>TIOL (taxindiaonline.com)</strong>,
            a long-standing name in Indian tax law reporting, to source pruned,
            curated case law. Instead of reasoning over raw, unfiltered
            judgments, Vedum’s AI works from decisions that have already been
            selected and organised for what matters to practitioners.
          </p>
          <p className="vd-lead">
            The result: sharper research briefs, citations you can verify in the
            TIOL format your practice already uses, and drafts built on the
            authorities that count.
          </p>
        </div>
        <div className="col-lg-5">
          <div className="vd-tiol-panel">
            <img src={tiolLogo} alt="TIOL — taxindiaonline.com" />
            <span className="vd-x">
              <span>VEDUM</span>
              <b>×</b>
              <span>TIOL</span>
            </span>
            <span className="text-muted small">
              AI research powered by curated Indian tax case law
            </span>
            <a
              href="https://www.taxindiaonline.com"
              target="_blank"
              rel="noreferrer"
            >
              Visit taxindiaonline.com →
            </a>
          </div>
        </div>
      </div>

      <div className="vd-pipeline">
        <h3 className="h5 mb-1">From judgment to answer</h3>
        <p className="text-muted mb-4">
          How curated case law flows into every Vedum response
        </p>
        <div className="row g-3 align-items-stretch">
          {STEPS.map((s, i) => (
            <React.Fragment key={s.k}>
              <div className="col-lg">
                <div
                  className={`vd-pipeline__step vd-pipeline__step--${s.variant}`}
                >
                  <div className="vd-step-k">{s.k}</div>
                  <h4>{s.t}</h4>
                  <p>{s.d}</p>
                </div>
              </div>
              {i < STEPS.length - 1 && (
                <div className="col-lg-auto vd-pipeline__arrow">
                  <Icon name="arrow" size={24} />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="row g-4 mt-2">
          {BENEFITS.map((b) => (
            <div className="col-md-4" key={b.b}>
              <div className="vd-benefit">
                <Icon name={b.icon} size={22} color="#1E3270" />
                <span>
                  <strong>{b.b}</strong> {b.t}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default TiolPartnership;
